import { render, staticRenderFns } from "./collocation.vue?vue&type=template&id=4e4ff2c3&scoped=true&"
import script from "./collocation.vue?vue&type=script&lang=ts&"
export * from "./collocation.vue?vue&type=script&lang=ts&"
import style0 from "./collocation.vue?vue&type=style&index=0&id=4e4ff2c3&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4e4ff2c3",
  null
  
)

export default component.exports